import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEmployeePermissionsDocument = gql`
  query SalesPortalEmployeePermissions($supplierUUID: uuid!, $userUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      businesses_employees(where: { employee_uuid: { _eq: $userUUID } }) {
        employee_permissions
        uuid
      }
    }
  }
`;
export function useSalesPortalEmployeePermissionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >(SalesPortalEmployeePermissionsDocument, options);
}
export function useSalesPortalEmployeePermissionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >(SalesPortalEmployeePermissionsDocument, options);
}
export type SalesPortalEmployeePermissionsQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeePermissionsQuery
>;
export type SalesPortalEmployeePermissionsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeePermissionsLazyQuery
>;
export type SalesPortalEmployeePermissionsQueryResult = Apollo.QueryResult<
  Types.SalesPortalEmployeePermissionsQuery,
  Types.SalesPortalEmployeePermissionsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEmployeePermissionsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEmployeePermissionsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >(SalesPortalEmployeePermissionsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEmployeePermissionsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEmployeePermissionsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEmployeePermissionsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEmployeePermissionsQuery,
    Types.SalesPortalEmployeePermissionsQueryVariables
  >(SalesPortalEmployeePermissionsDocument, lazyOptions);
}
